"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterLabelFilter = void 0;
// (C) 2007-2021 GoodData Corporation
var types_1 = require("../../../types");
function getFilterLabelFilter(item) {
    if (types_1.isBrokenAlertAttributeFilter(item)) {
        return {
            isAllSelected: item.isAllSelected,
            isDate: false,
            selection: item.selection,
            selectionSize: item.selectionSize,
            title: item.title,
        };
    }
    else {
        return {
            isAllSelected: false,
            isDate: true,
            selection: item.dateFilterTitle,
            selectionSize: null,
            title: item.title,
        };
    }
}
exports.getFilterLabelFilter = getFilterLabelFilter;
//# sourceMappingURL=filterUtils.js.map